import React, { useState } from "react";
import { Title } from "../../atoms";
import homeIcon from "../../../assets/images/home-icon.svg";
import menuIcon from "../../../assets/images/menu-icon.svg";
import crossIcon from "../../../assets/images/Path 387.svg";
import pastOrdersIcon from "../../../assets/images/past-orders-icon.svg";
import logoutIcon from "../../../assets/images/logout-icon.svg";
import portalIcon from "../../../assets/images/portal-icon.svg";
import { Link } from "react-router-dom";
const SideBar = ({ onSignout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const onSetSidebarOpen = (open) => {
    setSidebarOpen(open);
  };

  const data = [
    {
      title: "Home",
      image: homeIcon,
      route: "/notifications",
    },
    // {
    //   title: "Product availability",
    //   image: productIcon,
    //   route: "/dashboard",
    // },
    {
      title: "Past orders",
      image: pastOrdersIcon,
      route: "/pastOrders",
    },
    // {
    //   title: "How-to guide",
    //   image: questionIcon,
    //   route: "/dashboard",
    // },
    // {
    //   title: "Contact support",
    //   image: supportIcon,
    //   route: "/dashboard",
    // },
    {
      title: "Portal",
      image: portalIcon,
      route: process.env.REACT_APP_PORTAL_URL,
    },
  ];

  return sidebarOpen ? (
    <div
      className="sidebar-cont"
      onClick={() => {
        onSetSidebarOpen(false);
      }}
    >
      <div className="burger">
        <div className={"mainContainer"}>
          <div className={"row"}>
            <img
              src={crossIcon}
              className={"crossIcon"}
              onClick={() => onSetSidebarOpen(false)}
            />
          </div>
          {data.map((d, i) => (
            <div className={"item"} key={i}>
              {d.title === "Portal" ? (
                <a
                  className="link"
                  href={d.route}
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label="Portal"
                >
                  <div className="link-options text">
                    <img src={d.image} alt="menu-icon" />
                    {d.title}
                  </div>
                </a>
              ) : (
                <Link className={"link"} to={d.route}>
                  <div className="link-options text">
                    <img src={d.image} alt="menu-icon" />
                    {d.title}
                  </div>
                </Link>
              )}
            </div>
          ))}
          <div style={{ position: 'absolute', bottom: '0px'}} className={"item topS"} onClick={onSignout}>
            <img src={logoutIcon} />
            <Title text="Sign-out" className={"link-sign text"} />
          </div>
        </div>
      </div >
    </div >
  ) : (
    <img
      className={"menu"}
      src={menuIcon}
      onClick={() => onSetSidebarOpen(true)}
    />
  );
};

export default SideBar;
